<div class="modal-header w-100 p-0">
    <div
      class="w-100 plate plate-light_gray px-2 pt-3 pb-2 border-bottom-left-radius-0 border-bottom-right-radius-0 border-top-left-radius-modal border-top-right-radius-modal">
      <div class="d-flex justify-content-start align-items-center w-100 plate-header">
        <span class="text-dark text-size-16 ml-2 line-height-16">About This Course</span>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="row px-3">
        <span class="text-size-20 pb-4 font-weight-bold">
            Purchasing a full Sporty’s course will provide the best value to your learning. A full course gives you access to:
        </span>

        <span class="text-size-16 pb-1 font-weight-bold">Comprehensive Video-Based Training</span>
        <span class="text-size-12 line-height-14 font-weight-light pb-4">
            Your complete ground school and flight prep including the Full Video Course, iOS, Android, and TV Apps and progress syncing across devices.
        </span>

        <span class="text-size-16 pb-1 font-weight-bold">Robust Written Test Prep Program</span>
        <span class="text-size-12 line-height-14 font-weight-light pb-4">
            Multiple test prep modes including study by category, randomized questions, smart study, study marked questions, incorrect questions, flashcards. Performance reports and explanations included in all study modes.
        </span>

        <span class="text-size-16 pb-1 font-weight-bold">Written Test Endorsement</span>
        <span class="text-size-12 line-height-14 font-weight-light">
            Confidence and certification directly from the course. Other features include Unlimited Review History, Practice FAA Tests and Performance Analysis.
        </span>

    </div>
  </div>

  
<div class="modal-footer d-flex justify-content-between px-3">
    <div class="text-dark cursor-pointer" (click)="closeModal();">
        <span class="text-size-14">Close</span>
    </div>
    <div class="d-flex justify-content-start">
        <span class="text-dark text-size-16 d-flex align-items-center mr-2">$279</span>
        @if (course.inCoursePurchaseEnabled) {
            <a class="btn btn-primary btn-round" (click)="onBuyClick($event)">Purchase Course</a>
        } @else {
            <a href="https://www.sportys.com/learn-to-fly-course-private-pilot-test-prep-online-app-and-tv.html" target="_blank" class="btn btn-primary btn-round">Purchase Course</a>
          }
    </div>
</div>